import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 *@description
 * Check that zip
 * code is not empty
 * @return {any}
 * @function
 */
export const phoneNumberNotEmpty = function () {
  return function (control: AbstractControl): ValidationErrors | null {
    let invalid = false;
    const requiredAndNotEmpty = control.value.replace(/\s/g, '') !== '';
    if (!requiredAndNotEmpty) {
      invalid = true;
    }
    return invalid ? { isEmpty: true } : null;
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/modal-get-quote-info/form-validators/phone-number-not-empty.ts